import { type ComponentProps } from 'react';
import { Spinner as HeroSpinner } from '@heroui/react';
import { cn } from '../utils';

export type SpinnerProps = ComponentProps<typeof HeroSpinner> & {
  label?: string;
};

export const Spinner = ({
  className,
  color = 'accent',
  size = 'md',
  label,
  ...props
}: SpinnerProps) => (
  <span className="inline-flex flex-col items-center justify-center gap-3">
    <HeroSpinner className={cn(className)} color={color} size={size} {...props} />
    {label ? <span className="text-sm text-default-500">{label}</span> : null}
  </span>
);
